// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__TAmnO","question":"Question_question__2HPEL","description":"Question_description__3Nk-o"};